module.exports = __webpack_public_path__ + "img/reload_img.70b9c6a5.svg";